module.exports = __webpack_public_path__ + "63fe5d71d0ee61b9c771de850718c914.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.ttf?67495670
// module id = 964
// module chunks = 0